import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INVENTORYPARAMETERS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.InventoryParameters.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('value', 'Entity.InventoryParameters.Value')
    .required()
    .minLength(1)
    .maxLength(15)
    .build(),
  FieldBuilder
    .text('description', 'Entity.InventoryParameters.Description')
    .maxLength(100)
    .build(),
];

export const INVENTORYPARAMETERS_CONFIG = {
  entityName: 'InventoryParameters',
  localizationKey: 'Planning::Entity.InventoryParameters',
  fields: INVENTORYPARAMETERS_FIELDS,
  permission: 'PlanningInventory.InventoryParameterses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Inventory + MENU_NAME_SUFFIX,
};
